export class Company {
    id: number;
    name: string;

    short?: string;
    street?: string;
    number?: number;
    addition?: string;
    city?: string;
    postal_code?: string;
    humres?: string;
    email?: string;
    azure_project_id?: string;
    azure_team_id?: string;
    azure_desc?: string;
    afas_debtor_id?: string;

    curmonth?: number;
    prevmonth?: number;

    created_at: Date;
    updated_at: Date;
    deleted_at?: Date;
}
